import { FC } from "react";
import TMMSvg from "../../public/icons/TMM.svg";
import { IconProps, useAddMissingAntIconClass } from "../hooks/use-add-missing-ant-icon-class";

export const TMMIcon: FC<IconProps> = (iconProps) =>
  <span role="img" {...useAddMissingAntIconClass(iconProps)}><TMMSvg/></span>;
